import { Skeleton } from 'antd';

export const PaymentSkeleton = ({ active = false }) => (
  <Skeleton.Input
    active={active}
    style={{
      width: '10em',
      minWidth: 0,
      height: '1.8em',
    }}
  />
);
